import script from "./kalio-trix-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./kalio-trix-editor.vue?vue&type=script&setup=true&lang=ts"

import "./kalio-trix-editor.vue?vue&type=style&index=0&id=24da27a0&lang=scss"

const __exports__ = script;

export default __exports__